var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-wrapper"},[_c('p',[_vm._v(_vm._s(_vm.$t('paywall.form.click2pay.info.description')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }